import React, { Component } from "react";
import { Table, Button, Row, Col } from "antd";
import axios from "axios";
import PrintModal from '../components/PrintModal';
import moment from "moment-timezone";
import numeral from "numeral";
import "./Relatorios.css";

const { Column } = Table;

class EstoquePrintModal extends Component {
    state = {
        listaRegistros: [],
        visualizar: false,
        carregando: false,
    }

    componentDidUpdate(propsAnte, stateAnte) {
        if (!stateAnte.visualizar && this.state.visualizar) {
            this.getListaRegistros();
        }
    }

    getListaRegistros = () => {
        this.setState({ carregando: true, listaRegistros: [] });

        const { buscaDataIni, buscaDataFim, buscaProduto, buscaGrupoProduto, buscaUsuario, buscaOrdem } = this.props.filtros;

        let data_ini = '';
        if ((buscaDataIni) && (buscaDataIni !== undefined)) {
            data_ini = moment(buscaDataIni, 'DD/MM/YYYY').format('YYYY-MM-DD');
        }
        let data_fim = '';
        if ((buscaDataFim) && (buscaDataFim !== undefined)) {
            data_fim = moment(buscaDataFim, 'DD/MM/YYYY').format('YYYY-MM-DD');
        }

        axios
            .get('/estoque', {
                params: {
                    campoOrdem: buscaOrdem.campo,
                    tipoOrdem: buscaOrdem.ordem,
                    // usuario: buscaUsuario.key,
                    produto: buscaProduto.key,
                    grupo: buscaGrupoProduto.key,
                    data_ini,
                    data_fim,
                    print: 1
                }
            })
            .then(response => {
                this.setState({
                    listaRegistros: response.data,
                    carregando: false,
                });
            })
            .catch(erro => {
                console.warn(erro);
                this.setState({
                    carregando: false,
                });
            });
    };

    onCancelar = () => {
        this.setState({
            visualizar: false
        })
    }

    onVisualizar = () => {
        this.setState({
            visualizar: true
        })
    }

    renderValor = (ven_vlr_total, registro) => {
        return (
            <span> {numeral(parseFloat(ven_vlr_total)).format('0,000.00')} </span>
        );
    };

    renderData = (data) => {
        if (data) {
            const dataMoment = moment(data);
            return (
                <span>
                    {dataMoment.format('DD/MM/YYYY HH:mm')}
                </span>
            )
        } else {
            <span></span>
        }
    }

    renderUsuario = (usu_nome) => {
        return (
            <span>{usu_nome.substring(0, 7)}</span>
        );
    };

    renderStatus = (data, registro) => {
        if (registro.est_situacao === 'SIN') {
            const dataMoment = moment(data);
            return (
                <span style={{ fontSize: 11 }}>
                    {dataMoment.format('DD/MM/YYYY HH:mm')}
                </span>
            )
        } else {
            return (
                <span style={{ fontSize: 11 }}>{
                    registro.est_situacao === 'PEN' ?
                        <span style={{ fontSize: 11 }}>
                            PENDENTE
                        </span>
                        :
                        <span style={{ fontSize: 11 }}>
                            INVENTÁRIO
                        </span>
                }</span>
            )
        }
    }




    render() {
        const { listaRegistros, carregando, visualizar } = this.state;
        return (
            <span>
                <Button onClick={this.onVisualizar}>
                    Impressão
                </Button>

                <PrintModal
                    visible={visualizar}
                    onCancel={this.onCancelar}
                >
                    <div >
                        <div className="titulo">
                            Relatório de Estoque
                        </div>

                        {/* <Row>
                            <Col xs={24} style={{ marginTop: 14, textAlign: "center" }} >
                                <span style={{ fontWeight: "bold" }}>Total Pedidos: </span>
                                <span>R$ {this.renderValor(this.props.vlrTotalPed)}</span>

                                <span style={{ fontWeight: "bold", marginLeft: 30 }}>Qtde Pedidos: </span>
                                <span>{this.props.qtdePed}</span>

                                <span style={{ fontWeight: "bold", marginLeft: 30 }}>Total Orçamentos: </span>
                                <span>R$ {this.renderValor(this.props.vlrTotalOrc)}</span>

                                <span style={{ fontWeight: "bold", marginLeft: 30 }}>Qtde Orçamentos: </span>
                                <span>{this.props.qtdeOrc}</span>
                            </Col>
                        </Row> */}

                        <Table
                            pagination={false}
                            dataSource={listaRegistros}
                            className="tabela"
                            loading={{
                                spinning: carregando,
                                tip: 'Carregando. Aguarde...',
                                size: "large"
                            }}
                        >
                            <Column
                                key="est_data"
                                dataIndex="est_data"
                                title="Emissão"
                                render={this.renderData}
                                width={"10%"}
                                align="center"
                                className="listaCadastro"
                            />
                            <Column
                                key="grp_descricao"
                                dataIndex="grp_descricao"
                                title="Grupo"
                                width={"10%"}
                                align="left"
                                className="listaCadastro"
                            />
                            <Column
                                key="prod_codigo"
                                dataIndex="prod_codigo"
                                title="Produto"
                                width={"8%"}
                                align="center"
                                className="listaCadastro"
                            />
                            <Column
                                key="prod_descricao"
                                dataIndex="prod_descricao"
                                title="Descrição Produto"
                                width={"15%"}
                                align="left"
                                className="listaCadastro"
                            />
                            <Column
                                key="est_qtde_atual"
                                dataIndex="est_qtde_atual"
                                title="Qtde Atual"
                                render={this.renderValor}
                                width={"10%"}
                                align="right"
                                className="listaCadastro"
                            />
                            <Column
                                key="est_qtde_contada"
                                dataIndex="est_qtde_contada"
                                title="Qtde Contada"
                                render={this.renderValor}
                                width={"10%"}
                                align="right"
                                className="listaCadastro"
                            />
                            <Column
                                key="usu_nome"
                                dataIndex="usu_nome"
                                title="Usuário"
                                width={"15%"}
                                align="center"
                                className="listaCadastro"
                                render={this.renderUsuario}
                            />
                            <Column
                                key="est_data_sinc"
                                dataIndex="est_data_sinc"
                                title="Status"
                                render={this.renderStatus}
                                width={'10%'}
                                align="center"
                                className="listaCadastro"
                            />
                        </Table>
                    </div>

                </PrintModal>
            </span>
        );
    }
}

export default EstoquePrintModal;



// WEBPACK FOOTER //
// ./src/relatorios/EstoquePrintModal.js